import { AppConf } from '@appTypes/Conf'
import { defineStore } from 'pinia'

interface UrlConf {
  api_pflau_base_url: string
}

const useConfigStore = defineStore({
  id: 'appli-conf',
  state: (): UrlConf => {
    const persistedState = window.sessionStorage.getItem('app-conf')
    if (persistedState !== null) {
      return JSON.parse(persistedState) as UrlConf
    } else {
      return {
        api_pflau_base_url: ''
      }
    }
  },
  actions: {
    setInfoFromConf(value: AppConf) {
      this.api_pflau_base_url = value.API_PFLAU_BASE_URL
    },
    persistConf() {
      window.sessionStorage.setItem('app-conf', JSON.stringify(this.$state))
    },
    deletePersistedConf() {
      window.sessionStorage.removeItem('app-conf')
    }
  },
  getters: {
    isConfDefined: (state) => state.api_pflau_base_url.length > 0
  }
})

export default useConfigStore
